"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areasGetPropertyListingsInAreaAreasPropertyListingsGet = areasGetPropertyListingsInAreaAreasPropertyListingsGet;
const encodings_js_1 = require("../lib/encodings.js");
const M = __importStar(require("../lib/matchers.js"));
const primitives_js_1 = require("../lib/primitives.js");
const schemas_js_1 = require("../lib/schemas.js");
const security_js_1 = require("../lib/security.js");
const url_js_1 = require("../lib/url.js");
const errors = __importStar(require("../sdk/models/errors/index.js"));
const operations = __importStar(require("../sdk/models/operations/index.js"));
const shared = __importStar(require("../sdk/models/shared/index.js"));
const async_js_1 = require("../sdk/types/async.js");
/**
 * Get Property Listings In Area
 *
 * @remarks
 * Get property listings for an area.
 *
 * ## Valid query parameters
 *
 * <details>
 * <summary>Click to view information on valid query parameters for this endpoint</summary>
 *
 * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
 * with details why they are not valid.
 *
 * | Combination                       | Description                                                                                                                                                 |
 * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
 * | Postcode only                     | Will return only the listings in the postcode.                                                                                                            |
 * | Outcode only                      | Will return only the listings in the outcode.                                                                                                             |
 * | Single point parameter and radius | Will return all listings within the radius of the lat/lon given.                                                                                          |
 * | Multiple point parameters         | Will return all listings enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
 *
 * </details>
 *
 * ## Pagination
 *
 * <details>
 * <summary>Click to view information on using pagination for this endpoint</summary>
 *
 *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
 * </details>
 *
 * ## Multiple valued query parameters
 *
 * <details>
 * <summary>Click to view information on using query parameters that take multiple values</summary>
 *
 * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
 *
 * </details>
 *
 * ## Sorting
 *
 * <details>
 * <summary>Click to view information on using sorting for this endpoint</summary>
 *
 * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-sorting) for more information on using sorting.
 *
 * </details>
 */
function areasGetPropertyListingsInAreaAreasPropertyListingsGet(client, security, request, options) {
    return new async_js_1.APIPromise($do(client, security, request, options));
}
async function $do(client, security, request, options) {
    const parsed = (0, schemas_js_1.safeParse)(request, (value) => operations
        .GetPropertyListingsInAreaAreasPropertyListingsGetRequest$outboundSchema
        .parse(value), "Input validation failed");
    if (!parsed.ok) {
        return [parsed, { status: "invalid" }];
    }
    const payload = parsed.value;
    const body = null;
    const path = (0, url_js_1.pathToFunc)("/areas/property-listings")();
    const query = (0, encodings_js_1.encodeFormQuery)({
        "fields[listing]": payload["fields[listing]"],
        "filter[address_matched]": payload["filter[address_matched]"],
        "filter[agent_branch]": payload["filter[agent_branch]"],
        "filter[agent_company]": payload["filter[agent_company]"],
        "filter[agent_id]": payload["filter[agent_id]"],
        "filter[available]": payload["filter[available]"],
        "filter[company_owned]": payload["filter[company_owned]"],
        "filter[council_tax_band]": payload["filter[council_tax_band]"],
        "filter[energy_efficiency_current_rating]": payload["filter[energy_efficiency_current_rating]"],
        "filter[exclude_properties]": payload["filter[exclude_properties]"],
        "filter[garden_direction]": payload["filter[garden_direction]"],
        "filter[has_hmo]": payload["filter[has_hmo]"],
        "filter[has_reduction]": payload["filter[has_reduction]"],
        "filter[is_bungalow]": payload["filter[is_bungalow]"],
        "filter[latest_listing_only]": payload["filter[latest_listing_only]"],
        "filter[listing_quality]": payload["filter[listing_quality]"],
        "filter[listing_type]": payload["filter[listing_type]"],
        "filter[max_days_on_market]": payload["filter[max_days_on_market]"],
        "filter[max_days_since_listing]": payload["filter[max_days_since_listing]"],
        "filter[max_days_to_renewal]": payload["filter[max_days_to_renewal]"],
        "filter[max_estimated_value_rounded]": payload["filter[max_estimated_value_rounded]"],
        "filter[max_estimated_value]": payload["filter[max_estimated_value]"],
        "filter[max_internal_area_square_metres]": payload["filter[max_internal_area_square_metres]"],
        "filter[max_number_of_bathrooms]": payload["filter[max_number_of_bathrooms]"],
        "filter[max_number_of_bedrooms]": payload["filter[max_number_of_bedrooms]"],
        "filter[max_outdoor_space_area_square_metres]": payload["filter[max_outdoor_space_area_square_metres]"],
        "filter[max_price]": payload["filter[max_price]"],
        "filter[max_year_built]": payload["filter[max_year_built]"],
        "filter[max_years_at_property]": payload["filter[max_years_at_property]"],
        "filter[min_days_on_market]": payload["filter[min_days_on_market]"],
        "filter[min_days_since_listing]": payload["filter[min_days_since_listing]"],
        "filter[min_days_to_renewal]": payload["filter[min_days_to_renewal]"],
        "filter[min_estimated_value_rounded]": payload["filter[min_estimated_value_rounded]"],
        "filter[min_estimated_value]": payload["filter[min_estimated_value]"],
        "filter[min_internal_area_square_metres]": payload["filter[min_internal_area_square_metres]"],
        "filter[min_number_of_bathrooms]": payload["filter[min_number_of_bathrooms]"],
        "filter[min_number_of_bedrooms]": payload["filter[min_number_of_bedrooms]"],
        "filter[min_outdoor_space_area_square_metres]": payload["filter[min_outdoor_space_area_square_metres]"],
        "filter[min_price]": payload["filter[min_price]"],
        "filter[min_year_built]": payload["filter[min_year_built]"],
        "filter[min_years_at_property]": payload["filter[min_years_at_property]"],
        "filter[number_of_bathrooms]": payload["filter[number_of_bathrooms]"],
        "filter[number_of_bedrooms]": payload["filter[number_of_bedrooms]"],
        "filter[overseas_company_owned]": payload["filter[overseas_company_owned]"],
        "filter[property_type]": payload["filter[property_type]"],
        "filter[sectors]": payload["filter[sectors]"],
        "filter[show_only_inactive_listing]": payload["filter[show_only_inactive_listing]"],
        "filter[status]": payload["filter[status]"],
        "filter[tenure]": payload["filter[tenure]"],
        "outcode": payload.outcode,
        "page": payload.page,
        "point": payload.point,
        "postcode": payload.postcode,
        "radius": payload.radius,
        "results": payload.results,
        "sector": payload.sector,
        "sort": payload.sort,
    });
    const headers = new Headers((0, primitives_js_1.compactMap)({
        Accept: "application/json",
    }));
    const requestSecurity = (0, security_js_1.resolveSecurity)([
        {
            fieldName: "Authorization",
            type: "http:bearer",
            value: security?.bearer,
        },
    ], [
        {
            fieldName: "x-api-key",
            type: "apiKey:header",
            value: security?.xApiKey,
        },
    ]);
    const context = {
        options: client._options,
        baseURL: options?.serverURL ?? client._baseURL ?? "",
        operationID: "get_property_listings_in_area_areas_property_listings_get",
        oAuth2Scopes: null,
        resolvedSecurity: requestSecurity,
        securitySource: security,
        retryConfig: options?.retries
            || client._options.retryConfig
            || { strategy: "none" },
        retryCodes: options?.retryCodes || ["429", "500", "502", "503", "504"],
    };
    const requestRes = client._createRequest(context, {
        security: requestSecurity,
        method: "GET",
        baseURL: options?.serverURL,
        path: path,
        headers: headers,
        query: query,
        body: body,
        userAgent: client._options.userAgent,
        timeoutMs: options?.timeoutMs || client._options.timeoutMs || -1,
    }, options);
    if (!requestRes.ok) {
        return [requestRes, { status: "invalid" }];
    }
    const req = requestRes.value;
    const doResult = await client._do(req, {
        context,
        errorCodes: ["400", "404", "422", "429", "4XX", "500", "5XX"],
        retryConfig: context.retryConfig,
        retryCodes: context.retryCodes,
    });
    if (!doResult.ok) {
        return [doResult, { status: "request-error", request: req }];
    }
    const response = doResult.value;
    const responseFields = {
        HttpMeta: { Response: response, Request: req },
    };
    const [result] = await M.match(M.json(200, shared.AreaPropertyListingsResponse$inboundSchema), M.jsonErr(422, errors.FastAPIErrorAttributes$inboundSchema), M.jsonErr([400, 404, 429], errors.KrakenErrorAttributes$inboundSchema), M.jsonErr(500, errors.KrakenErrorAttributes$inboundSchema), M.fail("4XX"), M.fail("5XX"))(response, req, { extraFields: responseFields });
    if (!result.ok) {
        return [result, { status: "complete", request: req, response }];
    }
    return [result, { status: "complete", request: req, response }];
}
//# sourceMappingURL=areasGetPropertyListingsInAreaAreasPropertyListingsGet.js.map